module.exports = __webpack_public_path__ + "static/img/weixingroup.d0ba816.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage/weixingroup.png
// module id = kvCy
// module chunks = 0